import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { ContactoService } from '../../service/contacto.service'
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../service/seo.service';
import { NavigationEnd } from '@angular/router';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {
  sendok= true;
  notsendok= false;


  list: any = [
    {id: 1,name: 'Aguascalientes'},
    {id: 2,name: 'Baja California Nte'},
    {id: 3,name: 'Baja California Sur'},
    {id: 4,name: 'Campeche'},
    {id: 5,name: 'Coahuila'},
    {id: 6,name: 'Colima'},
    {id: 7,name: 'Chiapas'},
    {id: 8,name: 'Chihuahua'},
    {id: 9,name: 'Ciudad de México'},
    {id: 10,name: 'Durango'},
    {id: 11,name: 'Guanajuato'},
    {id: 12,name: 'Guerrero'},
    {id: 13,name: 'Hidalgo'},
    {id: 14,name: 'Jalisco'},
    {id: 15,name: 'Edo de Mex'},
    {id: 16,name: 'Michoacan'},
    {id: 17,name: 'Morelos'},
    {id: 18,name: 'Nayarit'},
    {id: 19,name: 'Nuevo Leon'},
    {id: 20,name: 'Oaxaca'},
    {id: 21,name: 'Puebla'},
    {id: 22,name: 'Queretaro'},
    {id: 23,name: 'Quintana Roo'},
    {id: 24,name: 'San Luis Potosi'},
    {id: 25,name: 'Sinaloa'},
    {id: 26,name: 'Sonora'},
    {id: 27,name: 'Tabasco'},
    {id: 28,name: 'Tamaulipas'},
    {id: 29,name: 'Tlaxcala'},
    {id: 30,name: 'Veracruz'},
    {id: 31,name: 'Yucatan'},
    {id: 32,name: 'Zacatecas'}
  ];
  
  paginaOrigen: string = 'Fundación BEST';

  
  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;
  

  constructor(
    private router: Router,
    public ContactoService:ContactoService,
    private meta: Meta,
    private title: Title,
    private _seoService: SeoService,
    private _urlcanonicaservice: UrlcanonicaService
    
    ) {
    
    this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.RouteText = event;
      this.getSEO(event.url)
    });
    
    }

  getAvisoPrivacidad(){
    this.router.navigate([]).then(result => {  window.open('aviso-de-privacidad', '_blank'); });
  }
  

  mandarContacto( data: NgForm ) {
    var estado = Number(data.value.estado);
   
    var params = {
      CNombre: data.value.nombre,
      CEmail: data.value.mail,
      CAsunto: data.value.asunto,
      CPaginaOrigen: this.paginaOrigen,
      CComentarios: data.value.comentarios,
      IdEstado: estado,
      CTelefono: data.value.telefono
    };

    this.ContactoService.enviarContacto(params).subscribe((resp: any) => {
      this.sendok = false;
      this.notsendok = true;
      // this.sendok = false;
      // this.notsendok = true;
    })
  }

  getSEO(page: string) {
    this._seoService.getSEO(page).subscribe((resp: any) => {
      console.log(resp)
      if (resp != null) {
        this.tituloseo = resp.titulo;
        this.descripcionseo = resp.descripcion;
        this.urlcanonicaseo = resp.urlcanonica;
        this.imagenseo = resp.imagen;
  
        this._urlcanonicaservice.createCanonicalLink();
        this.title.setTitle(this.tituloseo)
        this.meta.updateTag({
          name: 'description',
          content: this.descripcionseo
        })
  
        this.meta.updateTag({
          property: 'twitter:card',
          content: 'summary'
        })
        this.meta.updateTag({
          property: 'twitter:site',
          content: '@fundacionbest'
        })
        this.meta.updateTag({
          property: 'twitter:title',
          content: 'Fundación BEST'
        })
        this.meta.updateTag({
          property: 'twitter:description',
          content: this.descripcionseo
        })
        this.meta.updateTag({
          property: 'twitter:image',
          content: this.imagenseo
        })
  
        this.meta.updateTag({
          property: 'og:url',
          content: 'https://fundacionbest.org.mx/servicios'
        })
        this.meta.updateTag({
          property: 'og:title',
          content: this.tituloseo
        })
        this.meta.updateTag({
          property: 'og:image',
          content: this.imagenseo
        })
        this.meta.updateTag({
          property: 'og:description',
          content: this.descripcionseo
        })
      }
  
    });
  }

  ngOnInit(): void {
  }

}
